export default function isEmptyObj(obj: any) {
  if(!obj) return false;
  return Object.keys(obj).length === 0;
}
